var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"genericResourceBasicFormHost"},[(_vm.resolvedComponent)?_c(_vm.resolvedComponent,{ref:"inner",tag:"component",attrs:{"asset-type":_vm.assetType,"mode":_vm.mode,"rule-form":_vm.ruleForm},on:{"completion-changed":function($event){return _vm.$emit('completion-changed')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }